import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=682d65c5&scoped=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"
import style0 from "./layout.vue?vue&type=style&index=0&id=682d65c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682d65c5",
  null
  
)

export default component.exports